import React from 'react';
import { TotalCardColumn, TotalCardContainer } from './TotalCard.styled';
import { Typography, Tooltip } from '@mui/material';

interface Props {
  value: string | number;
  label: string;
  icon: React.ReactNode;
  width?: string;
  description?: string;
  fillAnimation?: boolean;
  fillPercentage?: number | string;
}

const TotalCard = ({
  value,
  label,
  icon,
  width = '250px',
  description,
  fillAnimation = false,
  fillPercentage = 0,
}: Props) => {
  return (
    <Tooltip title={description || ''} arrow placement="top">
      <TotalCardContainer width={width} fillAnimation={fillAnimation} fillPercentage={fillPercentage}>
        <TotalCardColumn>
          <Typography variant="body2">{label}</Typography>
          <Typography variant="subtitle1">{value}</Typography>
        </TotalCardColumn>
        {icon}
      </TotalCardContainer>
    </Tooltip>
  );
};

export default TotalCard;
